import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { enterpriseData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function EnterprisePage() {
    return <SolutionTemplate {...enterpriseData} />;
}
